<template>
  <NuxtRouteAnnouncer />
  <Confirm />
  <NuxtLayout>
    <NuxtPwaAssets />
    <NuxtPage />
  </NuxtLayout>
</template>
<style module>
@import url("~/css/main.css");
@import url("~/css/_helpers");
</style>
